import { makeBasicHeader, loadDeviceInfo } from "./utils";

// const axios = require('axios');

const DevAuthorize = class DevAuthorize {
    constructor(_vue) {
        if(_vue != null) {
            this.vue = _vue;
            this.token = _vue.$store.getters.getToken;
        }
        this.checkedRefresh = false;
    }

    isLogined() {
        // debugger;
        // console.log(this.token);
    
        if(!this.token) return false;
        if(!this.token.atoken || !this.token.rtoken || !this.token.key) return false;
    
        return true;
    }

    loadToken() {
        return this.token;
    }

    saveToken(data, _callback) {
        const _vue = this.vue;
        const atoken = data.access_token;
        const key = data.key;
        const token = {
            atoken : data.access_token,
            rtoken : data.refresh_token,
            key : data.key,
            name : data.name,
            device_id : data.device_id,
            icon : data.icon,
            authority : data.authority,
            scope : data.scope,
            source : data.source
        }
        this.token = token;
        _vue.$store.dispatch("saveToken", token).then(() => {
            // window.location.href = data.returnUrl;

            // this.$session.set('jwt', response.body.token)
            // Vue.http.headers.common['Authorization'] = 'Bearer ' + atoken;
            _vue.$http.defaults.headers.common['Authorization'] = 'Bearer ' + atoken;
            _vue.$http.defaults.headers.common['AuthorizationKey'] = key;

            _callback(true);
        });
    }
    
    updateToken(data) {
        const _vue = this.vue;
        const atoken = data.access_token;
        const key = data.key;
        const token = this.token;
        
        if(data.name) token.name = data.name;
        if(data.icon) token.icon = data.icon;

        this.token = token;
        _vue.$store.dispatch("saveToken", token).then(() => {
        });
    }
    
    

    login(email, password, token, _callback) {
        const _this = this;
        const _vue = this.vue;

        // console.log(this.username);
        // console.log(this.password);
        let formData = new FormData();
        formData.set("response_type", "grant");
        formData.set("email", email);
        formData.set("password", password);
        formData.set("token", token);
        formData.set("client_id", process.env.VUE_APP_OAUTH_CLIENT_ID);
        formData.set("scope", process.env.VUE_APP_OAUTH_CLIENT_SCOPE);
        formData.set("device_info", loadDeviceInfo());
        formData.set("state", loadDeviceInfo());

        // this.$http.post('/auth/authorize', {
        //   response_type: "grant",
        //   email: this.email,
        //   password: this.password,
        //   client_id: process.env.VUE_APP_OAUTH_CLIENT_ID,
        //   scope: process.env.VUE_APP_OAUTH_CLIENT_SCOPE,
        //   device_info: loadDeviceInfo()
        // }, {
        _vue.$http.defaults.headers.common['Authorization'] = makeBasicHeader(process.env.VUE_APP_OAUTH_CLIENT_ID, process.env.VUE_APP_OAUTH_CLIENT_SECRET);
        _vue.$http.post(
            '/auth/authorize',
            formData
        ).then(function (response) {
            // console.log(response);
            if (response.status === 200 && response.data) {
                // console.log(response.data);
                const data = response.data;
                const { code, message } = data;
                if(code === "1000") {
                    _this.saveToken(data, _callback);
                } else if(code === "2001" || code === "2002") {
                    _callback(true, code, "", data);
                } else {
                    _callback(false, code, message);
                }
            }
        }, function (err) {
            console.log('err', err)
            _callback(false, "", err);
        })
    }

    validate(_callback) {
        const _this = this;
        const _vue = this.vue;
        const token = this.token;

        if(token && token.atoken && token.key) {
            let formData = new FormData();
            formData.set("grant_type", "validate");
            formData.set("token", token.atoken);
            formData.set("key", token.key);
            formData.set("device_id", token.device_id || "");
            // formData.set("scope", process.env.VUE_APP_OAUTH_CLIENT_SCOPE);
            formData.set("device_info", loadDeviceInfo());
            formData.set("device_source", token.source || "");
    
            _vue.$http.defaults.headers.common['Authorization'] = makeBasicHeader(process.env.VUE_APP_OAUTH_CLIENT_ID, process.env.VUE_APP_OAUTH_CLIENT_SECRET);
            _vue.$http.post(
                '/auth/token',
                formData
            ).then(function (response) {
                // console.log(response);
                if (response.status === 200 && response.data) {
                    // console.log(response.data);
                    const data = response.data;
                    const { code, message } = data;
                    if(code === "1000") {
                        if (!_vue.$session.exists()) {
                            _vue.$session.start()
                        }
                        // this.$session.set('jwt', response.body.token)
                        // Vue.http.headers.common['Authorization'] = 'Bearer ' + atoken;
                        _vue.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token.atoken;
                        _vue.$http.defaults.headers.common['AuthorizationKey'] = token.key;

                        _callback(true);
                    } else if(token.rtoken && token.key) {
                        _this.refresh(_callback);
                    } else {
                        _vue.$store.dispatch("removeToken");
                        _callback(false, code, message);
                    }
                }
            }, function (err) {
                console.log('err', err)
                _callback(false, "", err);
            });
        } else if(token && token.rtoken && token.key) {
            _this.refresh(_callback);
        } else {
            // _vue.$store.dispatch("removeToken");
            _callback(false);
        }
    }

    refresh(_callback) {
        const _this = this;
        const _vue = this.vue;
        const token = this.token;

        let formData = new FormData();
        formData.set("grant_type", "refresh_token");
        formData.set("refresh_token", token.rtoken);
        formData.set("key", token.key);
        formData.set("device_id", token.device_id || "");
        formData.set("device_info", loadDeviceInfo());
        formData.set("device_source", token.source || "");
        // formData.set("scope", process.env.VUE_APP_OAUTH_CLIENT_SCOPE);
        // formData.set("state", loadDeviceInfo());
        
        _vue.$http.defaults.headers.common['Authorization'] = makeBasicHeader(process.env.VUE_APP_OAUTH_CLIENT_ID, process.env.VUE_APP_OAUTH_CLIENT_SECRET);
        _vue.$http.post(
            '/auth/token',
            formData
        ).then(function (response) {
            // console.log(response);
            if (response.status === 200 && response.data) {
                // console.log(response.data);
                const data = response.data;
                const { code, message } = data;
                if(code === "1000") {
                    // console.log("...save...token...by...refresh...token...");
                    // console.log(data);
                    
                    // 기존 데이터를 덮어쓰지 않기 위해 이전 값으로 변경..
                    data.refresh_token = token.rtoken;

                    // 토큰 저장...
                    _this.saveToken(data, _callback);
                    // _callback(false, code, message);
                } else {
                    _vue.$store.dispatch("removeToken");
                    _callback(false, code, message);
                }
            }
        }, function (err) {
            console.log('err', err)
            _callback(false, "", err);
        });
    }

    allowScope(_callback) {
        const _this = this;
        const _vue = this.vue;
        
        let formData = new FormData();
        formData.set("response_type", "scope");
        formData.set("allowed", "Y");

        _vue.$http.defaults.headers.common['Authorization'] = makeBasicHeader(process.env.VUE_APP_OAUTH_CLIENT_ID, process.env.VUE_APP_OAUTH_CLIENT_SECRET);
        _vue.$http.post(
            '/auth/authorize',
            formData
        ).then(function (response) {
            // console.log(response);
            if (response.status === 200 && response.data) {
                // console.log(response.data);
                const data = response.data;
                
                const { code, message } = data;
                if(code === "1000") {
                    _this.saveToken(data, _callback);
                } else {
                    // _vue.$store.dispatch("removeToken");
                    _callback(false, code, message);
                }
            }
        }, function (err) {
        console.log('err', err)
        })
    }

    logout(_callback) {
        const _vue = this.vue;
        const token = this.token;
        if(token.rtoken && token.key) {
            let formData = new FormData();
            formData.set("grant_type", "expire");
            formData.set("token", token.rtoken);
            formData.set("key", token.key);
    
            _vue.$http.defaults.headers.common['Authorization'] = makeBasicHeader(process.env.VUE_APP_OAUTH_CLIENT_ID, process.env.VUE_APP_OAUTH_CLIENT_SECRET);
            _vue.$http.post(
                '/auth/token',
                formData
            ).then(function (response) {
                // console.log(response);

                if (response.status === 200 && response.data) {
                    console.log(response.data);
                    const data = response.data;
                    const code = data.code;
                    if(code === "1000") {
                        _vue.$store.dispatch("removeToken");
                        _callback(true);
                    } else {
                        _vue.$store.dispatch("removeToken");
                        _callback(false);
                    }
                }
            }, function (err) {
                _vue.$store.dispatch("removeToken");
                console.log('err', err)
                _callback(false);
            });
        } else {
            _callback(false);
        }
    }

    prepare(_callback) {
        const _vue = this.vue;
        let formData = new FormData();
        formData.set("response_type", "token");

        _vue.$http.defaults.headers.common['Authorization'] = makeBasicHeader(process.env.VUE_APP_OAUTH_CLIENT_ID, process.env.VUE_APP_OAUTH_CLIENT_SECRET);

        _vue.$http.post(
            '/auth/authorize',
            formData
        ).then(function (response) {
            console.log(response);


            if (response.status === 200 && response.data) {
                console.log(response.data);
                const data = response.data;
                const code = data.code;
                const token = data.token;
                if(code === "1000") {
                    _callback(true, token);
                } else {
                    _callback(false);
                }
            }
        }, function (err) {
            console.log('err', err)
            _callback(false);
        });
    }


    ajax(method, url, data, _callback, withoutToken) {
        const _this = this;
        const _vue = this.vue;
        const token = this.token;

        if(withoutToken !== true) {
            _vue.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token.atoken;
            _vue.$http.defaults.headers.common['AuthorizationKey'] = token.key;

            if(!token || !token.atoken || !token.key) {
                _callback(false, "인증 토근이 없습니다.");
                return;
            }
        }

        var params = {};
        if(method === "get") {
            params = data;
        } else if(method === "post") {
            let formData = new FormData();
            for(const _key in data) {
                const _value = data[_key];
                formData.set(_key, _value);
            }
            params = formData;
            // params = data;
        } else if(method === "put") {
            //
            params = data;
        } else if(method === "patch") {
            //
            params = data;
        } else if(method === "delete") {
            //
            params = data;
        }
        _vue.$http({
            method,
            url,
            data : (method == "post") ? params : {},
            params : (method !== "post") ? params : {},
        }
        ).then(function (response) {
            // console.log(response);
            
            _this.checkedRefresh = false;

            if (response.status === 200 && response.data) {
                // console.log("call 200............");
                // console.log(response.data);
                const resdata = response.data;
                const code = resdata.code;
                if(code === "1000") {
                    _callback(true, resdata);
                } else {
                    _callback(false, resdata);
                }
            }
        }, function (error) {
            if(error.response.status !== 401) {
                // console.log("http error...not.401.........");
                console.log('err', error)
                _callback(false, error);
                return;
            }

            // Refresh Token 으로 새 Access Token 발급시도
            if(token.rtoken && token.key) {
                // console.log("do refresh..401..........");
                if(_this.checkedRefresh === true) {
                    _this.checkedRefresh = false;
                    _callback(false, "요청한 사항(" + url + ")에 대한 접근권한이 없습니다.");
                    return;
                }
                
                _this.refresh((res) => {
                    if(res) {
                        _this.checkedRefresh = true;
                        // console.log("refresh callback............" + res);
                        _this.ajax(method, url, data, _callback);
                    } else {
                        // console.log("refresh callback error............");
                        // _vue.$router.push('/login')
                        _callback(false, "접근 토근을 서버에서 받을 수 없습니다.");
                    }
                });
            } else {
                // console.log("refresh token is not exists............");
                _callback(false, "갱신 토근이 없습니다.");
            }
        });
    }
/*
    post(url, data, _callback) {
        const _this = this;
        const _vue = this.vue;
        const token = this.token;
        _vue.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token.atoken;
        _vue.$http.defaults.headers.common['AuthorizationKey'] = token.key;
        _vue.$http.post(
            url,
            data
        ).then(function (response) {
            console.log(response);
            if(response.status === 401) {
                // Refresh Token 으로 새 Access Token 발급시도
                _this.refresh((res) => {
                    if(res) {
                        _this.post(url, data, _callback);
                    } else {
                        _vue.$router.push('/login')
                        _callback(false);
                    }
                });
            } else if (response.status === 200 && response.data) {
                console.log(response.data);
                const data = response.data;
                const code = data.code;
                if(code === "1000") {
                    _callback(true, data);
                } else {
                    _callback(false);
                }
            }
        }, function (err) {
            console.log('err', err)
            _callback(false);
        });
    }
*/

    static login(_vue, email, password, token, _callback) {
        return new DevAuthorize(_vue).login(email, password, token, _callback);
    }

    static isLogined(_vue) {
        return new DevAuthorize(_vue).isLogined();
    }

    static loadToken(_vue) {
        return new DevAuthorize(_vue).loadToken();
    }

    static updateToken(_vue, details) {
        return new DevAuthorize(_vue).updateToken(details);
    }

    static validate(_vue, _callback) {
        return new DevAuthorize(_vue).validate(_callback);
    }

    static refresh(_vue, _callback) {
        return new DevAuthorize(_vue).refresh(_callback);
    }

    static allowScope(_vue, _callback) {
        return new DevAuthorize(_vue).allowScope(_callback);
    }

    static logout(_vue, _callback) {
        return new DevAuthorize(_vue).logout(_callback || function() {});
    }

    static prepare(_vue, _callback) {
        return new DevAuthorize(_vue).prepare(_callback || function() {});
    }

    static get(_vue, url, data, _callback, withoutToken) {
        return new DevAuthorize(_vue).ajax("get", url, data, _callback, withoutToken || false);
    }

    static post(_vue, url, data, _callback, withoutToken) {
        return new DevAuthorize(_vue).ajax("post", url, data, _callback, withoutToken || false);
    }

    static put(_vue, url, data, _callback, withoutToken) {
        return new DevAuthorize(_vue).ajax("put", url, data, _callback, withoutToken || false);
    }

    static patch(_vue, url, data, _callback, withoutToken) {
        return new DevAuthorize(_vue).ajax("patch", url, data, _callback, withoutToken || false);
    }

    static delete(_vue, url, data, _callback, withoutToken) {
        return new DevAuthorize(_vue).ajax("delete", url, data, _callback, withoutToken || false);
    }
}

export default DevAuthorize;
